export default "__VITE_ASSET__4ea669b3__"